export default __webpack_public_path__ + "7c55dd1051af3365c0e137416ff2fa6f.png";